export default __webpack_public_path__ + "static/media/10.43a5d26a.png";